import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock, User, ChevronRight, ShieldCheck } from 'lucide-react';
import { toast } from 'react-toastify';
import { motion } from 'framer-motion';

const Login = () => {
  const [credentials, setCredentials] = useState({ username: '', password: '' });
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setCredentials({ ...credentials, [e.target.name]: e.target.value });
  };

  const handleLogin = (e) => {
    e.preventDefault();
    setIsLoading(true);

    // Simulate API delay
    setTimeout(() => {
      const adminUser = process.env.REACT_APP_ADMIN_USERNAME || 'admin';
      const adminPass = process.env.REACT_APP_ADMIN_PASSWORD || 'admin123';

      if (credentials.username === adminUser && credentials.password === adminPass) {
        localStorage.setItem('isAdminAuthenticated', 'true');
        toast.success('Welcome back, Administrator');
        navigate('/admin');
      } else {
        toast.error('Invalid credentials. Please try again.');
        setIsLoading(false);
      }
    }, 800);
  };

  return (
    <div className="page login-page">
      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="login-card"
      >
        <div className="login-header">
          <div className="icon-container">
            <ShieldCheck color="white" size={32} />
          </div>
          <h2>Admin Access</h2>
          <p>Restricted personnel only</p>
        </div>

        <form onSubmit={handleLogin} className="login-form">
          <div className="input-group">
            <User size={18} className="input-icon" />
            <input
              type="text"
              name="username"
              placeholder="Username"
              value={credentials.username}
              onChange={handleChange}
              required
            />
          </div>

          <div className="input-group">
            <Lock size={18} className="input-icon" />
            <input
              type="password"
              name="password"
              placeholder="Password"
              value={credentials.password}
              onChange={handleChange}
              required
            />
          </div>

          <button
            type="submit"
            className="login-button"
            disabled={isLoading}
          >
            {isLoading ? 'Verifying...' : 'Login'} 
            {!isLoading && <ChevronRight size={18} />}
          </button>
        </form>
      </motion.div>
    </div>
  );
};

export default Login;